// extracted by mini-css-extract-plugin
export default {"expiresIn":"styles_expiresIn__+XgBf"};